<template>
  <div>
    <div v-if="loading">
      <b-spinner variant="primary" style="width: 3rem; height: 3rem;" label="Large Spinner"></b-spinner>
    </div>

    <b-row v-if="!loading">
      <div class="col-md-3 text-center text-md-right order-md-2">
        <div v-if="company.logo" class="pt-2">
          <v-lazy-image :src="company.logo" class="img-fluid" />
        </div>
      </div>

      <div class="col-md-9">
        <b-card>
          <div class="row">
            <div class="col-12">
              <h3 class="mb-0">{{ company.name }}</h3>
              <small
                class="text-black-50 font-weight-bold"
              >{{ company.code }} | {{ company.registration_number }}</small>
            </div>
          </div>

          <div class="row font-size-13 mt-3">
            <div class="col-lg-6">
              <table class="table">
                <tr>
                  <td class="border-0">
                    <i class="lni lni-phone-set text-primary"></i>
                  </td>
                </tr>
                <tr>
                  <td class="font-weight-bold w-50">Tel1</td>
                  <td>{{ company.contact_number }}</td>
                </tr>
                <tr>
                  <td class="font-weight-bold">Tel2</td>
                  <td>{{ company.contact_number_2 }}</td>
                </tr>
                <tr>
                  <td class="font-weight-bold">Fax</td>
                  <td>{{ company.contact_fax }}</td>
                </tr>
              </table>
            </div>
            <div class="col-lg-6">
              <table class="table">
                <tr>
                  <td class="border-0">
                    <i class="lni lni-envelope text-primary"></i>
                  </td>
                </tr>
                <tr>
                  <td class="font-weight-bold w-50">Email Accounts</td>
                  <td>{{ company.email_address_accounts }}</td>
                </tr>
                <tr>
                  <td class="font-weight-bold">Email Sales</td>
                  <td>{{ company.email_address_sales }}</td>
                </tr>
                <tr>
                  <td class="font-weight-bold">Email Info</td>
                  <td>{{ company.email_address_info }}</td>
                </tr>
                <tr>
                  <td class="font-weight-bold">Website</td>
                  <td>{{ company.website }}</td>
                </tr>
              </table>
            </div>
          </div>

          <div class="row font-size-13 mt-3">
            <div class="col-lg-6">
              <table class="table">
                <tr>
                  <td class="border-0">
                    <i class="lni lni-map-marker text-primary"></i>
                  </td>
                </tr>
                <tr>
                  <td class="font-weight-bold w-50">Physical</td>
                  <td class="nl2br">{{ company.physical_address }}</td>
                </tr>
              </table>
            </div>
            <div class="col-lg-6">
              <table class="table">
                <tr>
                  <td class="border-0">
                    <i class="lni lni-map-marker text-primary"></i>
                  </td>
                </tr>
                <tr>
                  <td class="font-weight-bold w-50">Postal</td>
                  <td class="nl2br">{{ company.postal_address }}</td>
                </tr>
              </table>
            </div>
          </div>

          <div class="row font-size-13 mt-3">
            <div class="col-lg-6">
              <table class="table">
                <tr>
                  <td class="border-0">
                    <i class="lni lni-money-protection text-primary"></i>
                  </td>
                </tr>
                <tr>
                  <td class="font-weight-bold w-50">Banking</td>
                  <td class="nl2br">{{ company.banking_details }}</td>
                </tr>
              </table>
            </div>
            <div class="col-lg-6">
              <table class="table">
                <tr>
                  <td class="border-0">
                    <i class="lni lni-calculator text-primary"></i>
                  </td>
                </tr>
                <tr>
                  <td class="font-weight-bold w-50">Charge Vat</td>
                  <td>
                    <i v-if="company.is_vatable == 1" class="lni lni-checkmark-circle text-success"></i>
                    <i v-if="company.is_vatable == 0" class="lni lni-cross-circle text-danger"></i>
                  </td>
                </tr>
                <tr v-if="company.is_vatable == 1">
                  <td class="font-weight-bold">Rate</td>
                  <td class="nl2br">{{ company.vat_rate }}%</td>
                </tr>
                <tr v-if="company.is_vatable == 1">
                  <td class="font-weight-bold">Number</td>
                  <td class="nl2br">{{ company.vat_number }}</td>
                </tr>
              </table>
            </div>
          </div>

          <div class="row">
            <div class="col-lg-6">
              <table class="table">
                <tr>
                  <td class="border-0">
                    <i class="lni lni lni-database text-primary"></i>
                  </td>
                </tr>
                <tr>
                  <td class="font-weight-bold w-50">Id</td>
                  <td>{{ company.id }}</td>
                </tr>
                <tr>
                  <td class="font-weight-bold">Created On</td>
                  <td>{{ moment(new Date(company.created_at)).format("DD MMM YYYY, HH:mm:ss") }}</td>
                </tr>
                <tr>
                  <td class="font-weight-bold">Updated On</td>
                  <td>{{ moment(new Date(company.updated_at)).format("DD MMM YYYY, HH:mm:ss") }}</td>
                </tr>
              </table>
            </div>
          </div>
        </b-card>
      </div>
    </b-row>
  </div>
</template>

<script>
import companyRepo from "@/api/repos/companyRepo";

export default {
  props: ["id"],

  mounted() {
    this.getCompany();
  },

  data() {
    return {
      loading: false,
      company: {
        company: "",
        permissions: [],
      },
    };
  },

  methods: {
    async getCompany() {
      try {
        this.loading = true;
        let { data } = await companyRepo.get(this.id);
        this.company = data.company;
        this.company.permissions = data.company.permissions;
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
